import React from 'react';
import logo from '../assets/damelio_logo_blanco.png';
import logo2 from '../assets/damelio_texto_blanco.png';

const LoaderWhite: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center h-screen">
      
      {/* Logos con hover conjunto */}
      <div className="text-center group transition-transform duration-300">
        <img
          src={logo}
          alt="Damelio Logo"
          className="mx-auto h-32 w-auto transition-transform duration-300"
        />
        <img
          src={logo2}
          alt="Damelio Extra Logo"
          className="mx-auto h-20 w-auto mt-2 transition-transform duration-300"
        />
      </div>

      {/* Loader animado */}
      <div className="mt-6 flex items-center justify-center">
        <div className="loader ease-linear rounded-full border-8 border-transparent border-t-black h-16 w-16 animate-spin"></div>
      </div>
    </div>
  );
};

export default LoaderWhite;
